import type { InvestmentProgramCode } from "@agroproj/backend/convex/constants/programs";

const INVESTMENT_PROGRAM_LABELS: Record<InvestmentProgramCode, string> = {
  pronamp: "PRONAMP",
  inovagro: "Inovagro",
  proirriga: "Proirriga",
  pca: "PCA",
  renovagro: "Renovagro",
  demais_investimentos: "Demais Investimentos",
};

export const INVESTMENT_PROGRAM_OPTIONS = Object.entries(INVESTMENT_PROGRAM_LABELS).map(
  ([value, label]) => ({
    label,
    value,
  }),
) as Array<{ label: string; value: InvestmentProgramCode }>;
